import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Typography} from '@mui/material';
import {Switch} from '@mui/material';
import {Theme} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import {FormControl, FormControlLabel, FormHelperText} from '@mui/material';
import {Switch} from '@mui/material';
import {PortalGroup} from '~common/lib/models/portal-group';
import {PortalGroupFeature} from '~common/lib/models/portal-group-feature';
import {Grid} from '@mui/material';
// import { PortalGroupVendor } from '~common/lib/models/portal-group-vendor';

import {PortalUser} from '~common/lib/models/portal-user';
import {PortalUserGroup} from '~common/lib/models/portal-user-group';

import {APIError, StringAttribute} from '~common/lib/types';
// import VendorAssignmentView from '~common/components/vendor-assignment-view';
import PortalUserContext, {FeatureArea} from '~common/lib/portal-user-context';
import portalUserContext from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  formControl: {
    width: '100%'
  },
  featureAreaHeading: {
    fontWeight: 600
  },
  featureAreaSubheading: {
    //paddingLeft: -15,
    //paddingRight: -15
  },
  featureGrid: {
    //paddingLeft: 30,
    //paddingRight: 30
  },
  root: {
    width: '100%'
  },
  formField: {
    width: '100%'
  },
  toolbar: {
    justifyContent: 'flex-end'
  },
  headerPaper: {
    padding: 30
  },
  userList: {
    // height: 300,
    // overflow: 'auto'
  },
  dangerButton: {
    backgroundColor: '#af0202',
    marginLeft: 10,
    '&:hover': {
      backgroundColor: '#5D0A0A !important'
    }
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  data: any;
  path: any;
  value: any;
  onCommitChange: Function;
}

type State = {
  featureAssignments: any;
};

class GroupFeatureRelationList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      featureAssignments: {}
    };
  }

 componentDidMount() {
    const fa = {};
    if (this.props.value && this.props.value.relations) {
      for (let i = 0; i < this.props.value.relations.length; i++) {
        const relation = this.props.value.relations[i];
        const feature = relation.value;
        fa[feature.key] = relation;
      }

      this.setState({featureAssignments: fa});
    }
  }

  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
    const fa = {};
    if (this.props.value && this.props.value.relations) {
      for (let i = 0; i < newProps.value.relations.length; i++) {
        const relation = newProps.value.relations[i];
        const feature = relation.value;
        fa[feature.key] = relation;
      }

      this.setState({featureAssignments: fa});
    }
  }

  handleFeatureSwitchChange = (featureKey: string) => (event: any) => {
    // console.log("handleFeatureSwitchChange")
    const {featureAssignments} = this.state;
    const featureAreas = PortalUserContext.featureAreas;
    const checked = event.target.checked;
    if (featureKey) {
      if (!checked) {
        delete featureAssignments[featureKey];
      } else {
        const uf = this.findUserFeature(featureKey);
        var rel = {};
        rel['label'] = uf.title;
        rel['value'] = uf;
        featureAssignments[featureKey] = rel;
      }
    }

    // const relations = Object.entries(featureAssignments).map((fa:any)=>{
    //   const key = fa[0]
    //   const value = fa[1]
    //   const rel = {}
    //   rel[key] = value
    // })
    // const relations = Object.values(featureAssignments);

    const relations = Object.keys(featureAssignments).map((i: any)=>{
      return featureAssignments[i]
    })

    // console.log('old/new', this.props.value.relations, relations);
    var data = {
      relations: {}
    }
    if (this.props.value) {
      data = this.props.value
    }

    if (data && data.relations) {
      data.relations = relations;
    } 
    

    if (this.props.onCommitChange) {
      this.props.onCommitChange(data);
    }
  };

  findUserFeature = (key: string) => {
    const featureAreas = PortalUserContext.featureAreas;
    for (var fa = 0; fa < featureAreas.length; fa++) {
      const featureArea = featureAreas[fa];
      for (var f = 0; f < featureArea.features.length; f++) {
        const feature = featureArea.features[f];
        if (feature.key == key) {
          return feature;
        }
      }
    }
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {data, value, path} = this.props;
    const {featureAssignments} = this.state;

    const featureAreas = PortalUserContext.featureAreas;

    // console.log("relation list data", data);

    const group = data;

    var sidx = 0;
    const featureAreasViews = featureAreas.map(
      (fa: FeatureArea, idx: number) => {
        var subAreas: any = {};

        // We will start off by converting the available feature areas into a suitable structure for rendering the areas.
        fa.features.forEach((f) => {
          // The features that we should display should be limited to
          // * If the restrictToUserType for the group is null, allow all features where requireAssignment is true.
          // * Otherwise, only show features where
          //     * feature.requireAssignment is true
          //     * feature.restrictToUserType is falsy or matches the group restrictToUserType
          if (f.requireAssignment) {
            if (
              !group.restrictToUserType ||
              !f.restrictToUserType ||
              f.restrictToUserType == group.restrictToUserType
            ) {
              var key = f.subAreaTitle ? f.subAreaTitle : 'none';
              if (!subAreas[key]) {
                subAreas[key] = {
                  title: f.subAreaTitle,
                  features: new Array<any>()
                };
              }

              subAreas[key].features.push(f);
            }
          }
        });

        let sal = new Array<any>();
        for (let key in subAreas) {
          sidx += 1;
          var sa = subAreas[key];
          var fidx = 0;
          let fl = sa.features.map((f: any, idx: number) => {
            // console.log('sdfsfd', f);
            fidx += 1;
            let chk =
              featureAssignments[f.key] != undefined &&
              featureAssignments[f.key] != null;
            return (
              <Grid
                key={'sa' + sidx + 'f' + fidx}
                item
                lg={3}
                md={4}
                sm={6}
                xs={12}>
                <FormControl className={classes.formControl}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={chk}
                        onChange={this.handleFeatureSwitchChange(f.key)}
                      />
                    }
                    label={f.title}
                  />
                </FormControl>
              </Grid>
            );
          });

          if (sa.title) {
            sal.push(
              <Grid key={'sa' + sidx} item xs={12}>
                <Typography
                  variant="subtitle1"
                  className={classes.featureAreaSubheading}
                  gutterBottom>
                  {sa.title}
                </Typography>
              </Grid>
            );
          }

          sal.push(fl);
        }

        // If a subarea has no items, no need to render it at all.
        if (sal.length == 0) {
          return null;
        }

        // console.log('sal', sal);

        return [
          <Grid key={'sa' + sidx} item xs={12}>
            <Typography
              key={'fa' + idx}
              variant="subtitle1"
              className={classes.featureAreaHeading}
              gutterBottom>
              {fa.title}
            </Typography>
          </Grid>,
          sal
        ];
      }
    );

    return (
      <div className={classes.container}>
        <Grid container>{featureAreasViews}</Grid>
      </div>
    );
  }
}

export default withStyles(styles)(GroupFeatureRelationList);
